module.exports = __webpack_public_path__ + "assets/images/crate-step1.84c41287.jpg";